import React, { FC, memo } from 'react';

import { ContainerProps, Svg } from '@lglp/components';

const CloseIcon: FC<ContainerProps> = ({ className, ...rest }) => (
  <Svg className={['close-icon', className]} viewBox="0 0 30 30" {...rest}>
    <path d="M2 28 L28 2 M2 2 L28 28" />
  </Svg>
);

export default memo(CloseIcon);
